import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './RoundedButton.scss';
import BaseButton from './BaseButton';

export default function RoundedButton({
  className,
  disabled,
  reverseColors,
  sleek,
  ...baseButtonProps
}) {
  const resolvedClassNames = classNames(
    {
      [s.rounded_button_disabled]: disabled,
      [s.rounded_button]: !disabled,
      [s.reversed_colors]: !disabled && reverseColors,
      [s.sleek]: sleek
    },
    className
  );

  return (
    <BaseButton className={resolvedClassNames} disabled={disabled} {...baseButtonProps} />
  );
}

RoundedButton.propTypes = {
  ...BaseButton.propTypes,
  reverseColors: PropTypes.bool,
  sleek: PropTypes.bool
};

RoundedButton.defaultProps = {
  ...BaseButton.defaultProps,
  reverseColors: false,
  sleek: false
};
